"use strict";

import { of, from } from "rxjs";
import { ajax } from "rxjs/ajax";
import { ofType } from "redux-observable";
import { mergeMap, catchError, map, concatMap } from "rxjs/operators";

import {
     requestTypes,
     commonConstants,
     dataTemplateConstants,
} from "../_constants";
import { getRequestHeader } from "../../_helpers/request.header";
import {
     ajaxError,
     dataTemplateAddComplete,
     dataTemplateAddSchemaValueComplete,
     dataTemplateAddTableRecordComplete,
     dataTemplateDeleteComplete,
     dataTemplateDeleteJsonSchemaComplete,
     dataTemplateEditTableRecordComplete,
     dataTemplateGetAllSchemeAttributeComplete,
     dataTemplateGetAllTypesComplete,
     dataTemplateGetComplete,
     dataTemplateGetJsonSchemaComplete,
     dataTemplateGetSchemaListComplete,
     dataTemplateGetSchemaListRequest,
     dataTemplateGetTableRecordComplete,
     dataTemplateGetUserAccountListComplete,
     dataTemplateGetValueComplete,
     dataTemplateGetValueRequest,
     dataTemplateListRequest,
     dataTemplateParticipantUserAccountCreateComplete,
     dataTemplateSchemaValueGetComplete,
     dataTemplateSchemaValueReOrderComplete,
     dataTemplateTypeComplete,
     dataTemplateTypeListComplete,
     dataTemplateUpdateComplete,
     dataTemplateValueDeleteComplete,
     dataTemplateValueUpdateComplete,
     getTemplateLabelsComplete,
     getTemplateTypesComplete,
} from "../_actions";

export const dataTemplateTypeListEpic = (actions$) => {
     return actions$.pipe(
          ofType(dataTemplateConstants.DATA_TEMPLATE_GET_TEMPLATE_LIST_REQUEST),
          mergeMap((action) => {
               return ajax
                    .post(
                         "/api/dataTemplate/templateType",
                         action.payload,
                         getRequestHeader(requestTypes.REQUEST_TYPE_POST),
                    )
                    .pipe(
                         map((ajaxResponse) => {
                              return dataTemplateTypeListComplete(
                                   ajaxResponse.response,
                              );
                         }),
                         catchError((error) => of(ajaxError(error))),
                    );
          }),
     );
};

export const addDataTemplateTypeEpic = (actions$) => {
     return actions$.pipe(
          ofType(dataTemplateConstants.DATA_TEMPLATE_ADD_REQUEST),
          mergeMap((action) => {
               const { navigate, ...payload } = action.payload;
               return ajax
                    .post(
                         "/api/dataTemplate/addDataTemplateType",
                         payload,
                         getRequestHeader(requestTypes.REQUEST_TYPE_POST),
                    )
                    .pipe(
                         map((ajaxResponse) => {
                              navigate("/app/data-templates-manage");
                              return dataTemplateAddComplete(
                                   ajaxResponse.response,
                              );
                         }),
                         catchError((error) => of(ajaxError(error))),
                    );
          }),
     );
};

export const dataTemplateCreateByCsvUploadEpic = (actions$) => {
     return actions$.pipe(
          ofType(dataTemplateConstants.DATA_TEMPLATE_CREATE_BY_CSV_REQUEST),
          mergeMap((action) => {
               const { closeFormModal, setDefault, form, ...payload } = action.payload;

               return ajax
                    .post(
                         "/api/dataTemplate/createByCsvUpload",
                         payload,
                         getRequestHeader(requestTypes.REQUEST_TYPE_POST),
                    )
                    .pipe(
                         map((ajaxResponse) => {
                              closeFormModal();
                              setDefault();
                              form.reset();
                              return factTableCreateByCsvUploadComplete(
                                   ajaxResponse.response,
                              );
                         }),
                         catchError((error) => of(ajaxError(error))),
                    );
          }),
     );
};

export const dataTemplateGetAllSchemeAttributeEpic = (actions$) => {
     return actions$.pipe(
          ofType(
               dataTemplateConstants.DATA_TEMPLATE_GET_ALL_SCHEME_ATTRIBUTE_REQUEST,
          ),
          mergeMap((action) => {
               return ajax
                    .post(
                         "/api/dataTemplate/dataTemplateGetAllSchemeAttribute",
                         action.payload,
                         getRequestHeader(requestTypes.REQUEST_TYPE_POST),
                    )
                    .pipe(
                         map((ajaxResponse) => {
                              return dataTemplateGetAllSchemeAttributeComplete(
                                   ajaxResponse.response,
                              );
                         }),
                         catchError((error) => of(ajaxError(error))),
                    );
          }),
     );
};

export const dataTemplateGetAllTypesEpic = (actions$) => {
     return actions$.pipe(
          ofType(dataTemplateConstants.DATA_TEMPLATE_GET_ALL_TYPES_REQUEST),
          mergeMap((action) => {
               return ajax
                    .post(
                         "/api/dataTemplate/dataTemplateGetAllTypes",
                         action.payload,
                         getRequestHeader(requestTypes.REQUEST_TYPE_POST),
                    )
                    .pipe(
                         map((ajaxResponse) => {
                              return dataTemplateGetAllTypesComplete(
                                   ajaxResponse.response,
                              );
                         }),
                         catchError((error) => of(ajaxError(error))),
                    );
          }),
     );
};

export const dataTemplateValueDeleteEpic = (actions$) => {
     return actions$.pipe(
          ofType(
               dataTemplateConstants.DATA_TEMPLATE_SCHEMA_VALUE_DELETE_REQUEST,
          ),
          mergeMap((action) => {
               const { factTableId, ...payload } = action.payload;

               return ajax
                    .post(
                         "/api/dataTemplate/deleteDataTemplateSchema",
                         payload,
                         getRequestHeader(requestTypes.REQUEST_TYPE_POST),
                    )
                    .pipe(
                         concatMap((ajaxResponse) =>
                              of(
                                   dataTemplateValueDeleteComplete(
                                        ajaxResponse.response,
                                   ),
                                   dataTemplateGetSchemaListRequest({
                                        page: 1,
                                        pageSize: 100,
                                        factTableId,
                                        search: "",
                                   }),
                              ),
                         ),
                         catchError((error) => of(ajaxError(error))),
                    );
          }),
     );
};

export const dataTemplateSchemaValueGetEpic = (actions$) => {
     return actions$.pipe(
          ofType(dataTemplateConstants.DATA_TEMPLATE_SCHEMA_VALUE_GET_REQUEST),
          mergeMap((action) => {
               return ajax
                    .post(
                         "/api/dataTemplate/dataTemplateSchemaValueGet",
                         action.payload,
                         getRequestHeader(requestTypes.REQUEST_TYPE_POST),
                    )
                    .pipe(
                         map((ajaxResponse) => {
                              return dataTemplateSchemaValueGetComplete(
                                   ajaxResponse.response,
                              );
                         }),
                         catchError((error) => of(ajaxError(error))),
                    );
          }),
     );
};

export const dataTemplateListEpic = (actions$) => {
     return actions$.pipe(
          ofType(dataTemplateConstants.DATA_TEMPLATE_LIST_REQUEST),
          mergeMap((action) => {
               return ajax
                    .post(
                         "/api/dataTemplate/dataTemplateList",
                         action.payload,
                         getRequestHeader(requestTypes.REQUEST_TYPE_POST),
                    )
                    .pipe(
                         map((ajaxResponse) => {
                              return dataTemplateTypeComplete(
                                   ajaxResponse.response,
                              );
                         }),
                         catchError((error) => of(ajaxError(error))),
                    );
          }),
     );
};

export const dataTemplateGetAllSchemaListEpic = (actions$) => {
     return actions$.pipe(
          ofType(
               dataTemplateConstants.DATA_TEMPLATE_GET_ALL_SCHEMA_LIST_REQUEST,
          ),
          mergeMap((action) => {
               return ajax
                    .post(
                         "/api/dataTemplate/dataTemplateGetAllSchemaList",
                         action.payload,
                         getRequestHeader(requestTypes.REQUEST_TYPE_POST),
                    )
                    .pipe(
                         map((ajaxResponse) => {
                              return dataTemplateGetSchemaListComplete(
                                   ajaxResponse.response,
                              );
                         }),
                         catchError((error) => of(ajaxError(error))),
                    );
          }),
     );
};


export const dataTemplateSchemaValueReOrderEditEpic = (actions$) => {
     return actions$.pipe(
          ofType(
               dataTemplateConstants.DATA_TEMPLATE_SCHEMA_VALUE_REORDER_REQUEST,
          ),
          mergeMap((action) => {
               const { ...payload } = action.payload;

               return ajax
                    .post(
                         "/api/dataTemplate/dataTemplateSchemaValueReOrder",
                         payload,
                         getRequestHeader(requestTypes.REQUEST_TYPE_POST),
                    )
                    .pipe(
                         concatMap((ajaxResponse) => {
                              return of(
                                   dataTemplateSchemaValueReOrderComplete(
                                        ajaxResponse.response,
                                   ),
                                   dataTemplateGetSchemaListRequest({
                                        page: 1,
                                        pageSize: 100,
                                        factTableId: action.payload.dataTemplateId,
                                        search: "",
                                   }),
                              );
                         }),
                         catchError((error) => of(ajaxError(error))),
                    );
          }),
     );
};

export const dataTemplateGetJsonSchemaEpic = (actions$) => {
     return actions$.pipe(
          ofType(dataTemplateConstants.GET_DATA_TEMPLATE_JSON_SCHEMA_REQUEST),
          mergeMap((action) => {
               const { ...payload } = action.payload;

               return ajax
                    .post(
                         "/api/dataTemplate/getJsonSchema",
                         payload,
                         getRequestHeader(requestTypes.REQUEST_TYPE_POST),
                    )
                    .pipe(
                         map((ajaxResponse) => {
                              return dataTemplateGetJsonSchemaComplete(
                                   ajaxResponse.response,
                              );
                         }),
                         catchError((error) => of(ajaxError(error))),
                    );
          }),
     );
};

export const dataTemplateGetValueEpic = (actions$) => {
     return actions$.pipe(
          ofType(dataTemplateConstants.DATA_TEMPLATE_GET_VALUE_REQUEST),
          mergeMap((action) => {
               const { ...payload } = action.payload;

               return ajax
                    .post(
                         "/api/dataTemplate/getValues",
                         payload,
                         getRequestHeader(requestTypes.REQUEST_TYPE_POST),
                    )
                    .pipe(
                         map((ajaxResponse) => {
                              return dataTemplateGetValueComplete(
                                   ajaxResponse.response,
                              );
                         }),
                         catchError((error) => of(ajaxError(error))),
                    );
          }),
     );
};

export const dataTemplateRecordEpic = (actions$) => {
     return actions$.pipe(
          ofType(dataTemplateConstants.DATA_TEMPLATE_ADD_SCHEMA_RECORD_REQUEST),
          mergeMap((action) => {
               const { closeModal, ...payload } =
                    action.payload;
               return ajax
                    .post(
                         "/api/dataTemplate/dataTableAddRecord",
                         payload,
                         getRequestHeader(requestTypes.REQUEST_TYPE_POST),
                    )
                    .pipe(
                         map((ajaxResponse) => {
                              return dataTemplateAddTableRecordComplete(
                                   ajaxResponse.response,
                              );
                         }),
                         concatMap((ajaxResponse) => {
                              closeModal()
                              return of(
                                   dataTemplateAddTableRecordComplete(
                                        ajaxResponse.response,
                                   ),
                                   dataTemplateGetValueRequest({
                                        page: 1,
                                        pageSize: 5,
                                        dataTemplateId: action.payload.dataTemplateId,
                                        search: "",
                                   }),
                              );
                         }),
                         catchError((error) => of(ajaxError(error))),
                    );
          }),
     );
};



export const dataTemplateGetTableRecordEpic = (actions$) => {
     return actions$.pipe(
          ofType(dataTemplateConstants.DATA_TEMPLATE_GET_SCHEMA_RECORD_REQUEST),
          mergeMap((action) => {
               const { ...payload } = action.payload;

               return ajax
                    .post(
                         "/api/dataTemplate/getDataTemplateRecord",
                         payload,
                         getRequestHeader(requestTypes.REQUEST_TYPE_POST),
                    )
                    .pipe(
                         map((ajaxResponse) => {
                              return dataTemplateGetTableRecordComplete(
                                   ajaxResponse.response,
                              );
                         }),
                         catchError((error) => of(ajaxError(error))),
                    );
          }),
     );
};

export const dataTemplateEditTableRecordEpic = (actions$) => {
     return actions$.pipe(
          ofType(
               dataTemplateConstants.DATA_TEMPLATE_EDIT_SCHEMA_RECORD_REQUEST,
          ),
          mergeMap((action) => {
               const { getManageDataList, closeModal, ...payload } =
                    action.payload;

               return ajax
                    .post(
                         "/api/dataTemplate/updateDataTemplateRecord",
                         payload,
                         getRequestHeader(requestTypes.REQUEST_TYPE_POST),
                    )
                    .pipe(
                         map((ajaxResponse) => {
                              getManageDataList();
                              closeModal();
                              return dataTemplateEditTableRecordComplete(
                                   ajaxResponse.response,
                              );
                         }),
                         catchError((error) => of(ajaxError(error))),
                    );
          }),
     );
};

export const dataTemplateDeleteEpic = (actions$) => {
     return actions$.pipe(
          ofType(dataTemplateConstants.DATA_TEMPLATE_DELETE_REQUEST),
          mergeMap((action) => {
               const { page, pageSize, ...payload } = action.payload;

               return ajax
                    .post(
                         "/api/dataTemplate/delete",
                         payload,
                         getRequestHeader(requestTypes.REQUEST_TYPE_POST),
                    )
                    .pipe(
                         concatMap((ajaxResponse) =>
                              of(
                                   dataTemplateDeleteComplete(
                                        ajaxResponse.response,
                                   ),
                                   dataTemplateListRequest({
                                        page: page,
                                        pageSize: pageSize,
                                   }),
                              ),
                         ),
                         catchError((error) => of(ajaxError(error))),
                    );
          }),
     );
};

export const dataTemplateGetEpic = (actions$) => {
     return actions$.pipe(
          ofType(dataTemplateConstants.DATA_TEMPLATE_GET_REQUEST),
          mergeMap((action) => {
               return ajax
                    .post(
                         "/api/dataTemplate/get",
                         action.payload,
                         getRequestHeader(requestTypes.REQUEST_TYPE_POST),
                    )
                    .pipe(
                         map((ajaxResponse) => {
                              return dataTemplateGetComplete(
                                   ajaxResponse.response,
                              );
                         }),
                         catchError((error) => of(ajaxError(error))),
                    );
          }),
     );
};

export const dataTemplateEditEpic = (actions$) => {
     return actions$.pipe(
          ofType(dataTemplateConstants.DATA_TEMPLATE_UPDATE_REQUEST),
          mergeMap((action) => {
               const { navigate, ...payload } = action.payload;

               return ajax
                    .post(
                         "/api/dataTemplate/edit",
                         payload,
                         getRequestHeader(requestTypes.REQUEST_TYPE_POST),
                    )
                    .pipe(
                         map((ajaxResponse) => {
                              navigate("/app/data-templates-manage");
                              return dataTemplateUpdateComplete(
                                   ajaxResponse.response,
                              );
                         }),
                         catchError((error) => of(ajaxError(error))),
                    );
          }),
     );
};

export const getDataTemplateLablesEpic = (actions$) => {
     return actions$.pipe(
          ofType(dataTemplateConstants.GET_DATA_TEMPLATE_LABELS_REQUEST),
          mergeMap((action) => {
               return ajax
                    .get(
                         "/api/dataTemplate/templateLabels",
                         getRequestHeader(requestTypes.REQUEST_TYPE_GET),
                    )
                    .pipe(
                         map((ajaxResponse) => {
                              return getTemplateLabelsComplete(
                                   ajaxResponse.response,
                              );
                         }),
                         catchError((error) => of(ajaxError(error))),
                    );
          }),
     );
};

export const getDataTemplateTypesEpic = (actions$) => {
     return actions$.pipe(
          ofType(dataTemplateConstants.GET_DATA_TEMPLATE_TYPES_REQUEST),
          mergeMap((action) => {
               return ajax
                    .get(
                         "/api/dataTemplate/dataTemplateTypes",
                         getRequestHeader(requestTypes.REQUEST_TYPE_GET),
                    )
                    .pipe(
                         map((ajaxResponse) => {
                              return getTemplateTypesComplete(
                                   ajaxResponse.response,
                              );
                         }),
                         catchError((error) => of(ajaxError(error))),
                    );
          }),
     );
};

export const dataTemplateValueEditEpic = (actions$) => {
     return actions$.pipe(
          ofType(dataTemplateConstants.DATA_TEMPLATE_VALUE_UPDATE_REQUEST),
          mergeMap((action) => {
               const { closeFormModal, ...payload } = action.payload;

               return ajax
                    .post(
                         "/api/dataTemplate/updateValueDataTemplateSchema",
                         payload,
                         getRequestHeader(requestTypes.REQUEST_TYPE_POST),
                    )
                    .pipe(
                         concatMap((ajaxResponse) => {
                              closeFormModal();
                              return of(
                                   dataTemplateValueUpdateComplete(
                                        ajaxResponse.response,
                                   ),
                                   dataTemplateGetSchemaListRequest({
                                        page: 1,
                                        pageSize: 100,
                                        factTableId: action.payload.dataTemplateId,
                                        search: "",
                                   }),
                              );
                         }),
                         catchError((error) => of(ajaxError(error))),
                    );
          }),
     );
};

export const dataTemplateJsonSchemaDeleteEpic = (actions$) => {
     return actions$.pipe(
          ofType(dataTemplateConstants.DATA_TEMPLATE_JSON_SCHEMA_DELETE_REQUEST),
          mergeMap((action) => {
               const { ...payload } = action.payload;

               return ajax
                    .post(
                         "/api/dataTemplate/deleteJsonSchema",
                         payload,
                         getRequestHeader(requestTypes.REQUEST_TYPE_POST),
                    )
                    .pipe(
                         concatMap((ajaxResponse) => {
                              return of(
                                   dataTemplateDeleteJsonSchemaComplete(
                                        ajaxResponse.response,
                                   ),
                                   dataTemplateGetSchemaListRequest({
                                        page: 1,
                                        pageSize: 100,
                                        factTableId: payload.dataTableId,
                                        search: "",
                                   }),
                              );
                         }),
                         catchError((error) => of(ajaxError(error))),
                    );
          }),
     );
};


export const dataTemplateAddSchemaValuesEpic = (actions$) => {
     return actions$.pipe(
          ofType(dataTemplateConstants.DATA_TEMPLATE_ADD_SCHEMA_VALUE_REQUEST),
          mergeMap((action) => {
               const { closeFormModal, ...payload } = action.payload;
               return ajax
                    .post(
                         "/api/dataTemplate/dataTemplateAddSchemaValues",
                         payload,
                         getRequestHeader(requestTypes.REQUEST_TYPE_POST),
                    )
                    .pipe(
                         concatMap((ajaxResponse) => {
                              closeFormModal();
                              return of(
                                   dataTemplateAddSchemaValueComplete(
                                        ajaxResponse.response,
                                   ),
                                   dataTemplateGetSchemaListRequest({
                                        page: 1,
                                        pageSize: 100,
                                        factTableId: payload.dataTemplateId,
                                        search: "",
                                   }),
                              );
                         }),
                         catchError((error) => of(ajaxError(error))),
                    );
          }),
     );
};

export const dataTemplateGetParticipantAccountListEpic = (actions$) => {
     return actions$.pipe(
          ofType(dataTemplateConstants.DATA_TEMPLATE_GET_USER_ACCOUNT_REQUEST),
          mergeMap((action) => {
               const { closeFormModal, ...payload } = action.payload;
               return ajax
                    .post(
                         "/api/dataTemplate/dataTemplateGetParticipantUser",
                         payload,
                         getRequestHeader(requestTypes.REQUEST_TYPE_POST),
                    )
                    .pipe(
                         concatMap((ajaxResponse) => {

                              return of(
                                   dataTemplateGetUserAccountListComplete(
                                        ajaxResponse.response,
                                   ),
                              );
                         }),
                         catchError((error) => of(ajaxError(error))),
                    );
          }),
     );
};

export const dataTemplateParticipantUserAccountCreateEpic = (actions$) => {
     return actions$.pipe(
          ofType(dataTemplateConstants.DATA_TEMPLATE_PARTICIPANT_USER_ACCOUNT_CREATE_REQUEST),
          mergeMap((action) => {
               const { openSuccess, ...payload } = action.payload;
               return ajax
                    .post(
                         "/api/dataTemplate/dataTemplateParticipantUserCreate",
                         payload,
                         getRequestHeader(requestTypes.REQUEST_TYPE_POST),
                    )
                    .pipe(
                         concatMap((ajaxResponse) => {
                              openSuccess()
                              return of(
                                   dataTemplateParticipantUserAccountCreateComplete(
                                        ajaxResponse.response,
                                   ),
                              );
                         }),
                         catchError((error) => of(ajaxError(error))),
                    );
          }),
     );
};


